// extracted by mini-css-extract-plugin
module.exports = {"overflowText":"style_overflowText__33_ab","teamFontName":"style_teamFontName__2F2Ww style_overflowText__33_ab","fontFamily":"style_fontFamily__22xaB style_overflowText__33_ab"};